/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { favoriteFontAdd } from '../fn/favorite-font/favorite-font-add';
import { FavoriteFontAdd$Params } from '../fn/favorite-font/favorite-font-add';
import { favoriteFontRemove } from '../fn/favorite-font/favorite-font-remove';
import { FavoriteFontRemove$Params } from '../fn/favorite-font/favorite-font-remove';

@Injectable({ providedIn: 'root' })
export class FavoriteFontService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `favoriteFontAdd()` */
  static readonly FavoriteFontAddPath = '/api/FavoriteFont/{menuId}/add/{fontName}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `favoriteFontAdd()` instead.
   *
   * This method doesn't expect any request body.
   */
  favoriteFontAdd$Response(params: FavoriteFontAdd$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return favoriteFontAdd(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `favoriteFontAdd$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  favoriteFontAdd(params: FavoriteFontAdd$Params, context?: HttpContext): Observable<void> {
    return this.favoriteFontAdd$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `favoriteFontRemove()` */
  static readonly FavoriteFontRemovePath = '/api/FavoriteFont/{menuId}/remove/{fontName}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `favoriteFontRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  favoriteFontRemove$Response(params: FavoriteFontRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return favoriteFontRemove(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `favoriteFontRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  favoriteFontRemove(params: FavoriteFontRemove$Params, context?: HttpContext): Observable<void> {
    return this.favoriteFontRemove$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
